<div class="row text-center animated fadeIn">
    <div class="col">
      <div class="spinner-border" style="width: 3rem; height: 3rem; color: #67a4c8;" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <div class="spinner-grow" style="width: 3rem; height: 3rem; color: #fdca3f;" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
</div>